import { render, staticRenderFns } from "./RemoveFacebookCampaignAction.vue?vue&type=template&id=147d7d9a"
import script from "./RemoveFacebookCampaignAction.vue?vue&type=script&lang=js"
export * from "./RemoveFacebookCampaignAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports